import React, { useEffect, useState } from "react";
import {
  enterFirstName,
  errEmptyEmailOrPhone,
  validEmail_OR_MobileNumberText,
  validEmailText,
  validFirstName,
  validMobileNumberText,
} from "../../dataBaseFile/error";
import { emailValidation, firstNameValidation, noSpaceOnChange, phoneValidation } from "../../validations/validation";
import InputField from "../../jsx/components/fields/inputField";
import { lblFirstName } from "../../dataBaseFile/label";
import EmailPhoneCombine from "../../jsx/components/fields/emailPhoneField";
import TextArea from "../../jsx/components/fields/textArea";
import { useDispatch } from "react-redux";
import guestHomeownerForumApi from "../../service/api/guestUsers/guestHomeownerForum";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";

const EMPTY = { name: "", email: "", phone: "" };

export default function NotYetLeadForm({
  onClose,
  onSubmit,
  onDone,
  title = "Check back later",
  prompt = "Leave your info and we'll follow up. Email or phone is required.",
  submitLabel = "Submit",
}) {
  const dispatch = useDispatch();
  const [fields, setFields] = useState(EMPTY);
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");

  const [firstName, setFirstName] = useState("");
  const [isFirstNameError, setIsFirstNameError] = useState(false);
  const [errorFirstNameMsg, setErrorFirstNameMsg] = useState("");

  const [isEmailPhoneVal, setIsEmailPhoneVal] = useState(false);
  const [emailPhoneValue, setEmailPhoneValue] = useState(localStorage.getItem("emailCompanyInvite") ? localStorage.getItem("emailCompanyInvite") : localStorage.getItem("phoneNumberCompanyInvite") ? localStorage.getItem("phoneNumberCompanyInvite") : "");
  const [codeValue, setCodeValue] = useState(localStorage.getItem("phoneCodeCompanyInvite") ? localStorage.getItem("phoneCodeCompanyInvite") : 1);
  const [isPhone, setIsPhone] = useState(false);
  const [loginErrorMsg, setLoginErrorMsg] = useState("");

  const [messageText, setMessageText] = useState("");

  const [toasterType, setToasterType] = useState();
  const [handleToaster, setHandleToaster] = useState(false);
  const [responceMsg, setResponceMsg] = useState("");

  const setField = (key) => (e) => {
    setFields((prev) => ({ ...prev, [key]: e.target.value }));
    setErrors((prev) => ({
      ...prev,
      [key]: "",
      contact: "",
    }));
    setSubmitError("");
  };

  const validate = () => {
    const next = {};
    const email = fields.email.trim();
    const phoneDigits = fields.phone.replace(/\D/g, "");

    if (!fields.name.trim()) next.name = "Name is required";

    if (!email && !fields.phone.trim()) {
      next.contact = errEmptyEmailOrPhone;
    } else {
      if (email && !emailValidation(email)) {
        next.email = validEmailText;
      }
      if (fields.phone.trim() && !phoneValidation(phoneDigits)) {
        next.phone = validMobileNumberText;
      }
    }

    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // if (!validate()) return;

    // setSubmitting(true);
    setSubmitError("");

    // try {
    //   const result = onSubmit?.({
    //     ...fields,
    //     phone: fields.phone.replace(/\D/g, ""),
    //   });
    //   if (result?.then) {
    //     await result;
    //   }
    //   setSubmitted(true);
    // } catch {
    //   setSubmitError("Something went wrong. Please try again.");
    // } finally {
    //   setSubmitting(false);
    // }

    if (!firstNameValidation(firstName)) {
      setIsFirstNameError(true)
      if (firstName === "") {
        setErrorFirstNameMsg(enterFirstName);
      } else {
        setErrorFirstNameMsg(validFirstName);
      }
    }

    if (!isPhone) {
      if (!emailValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
        if (emailPhoneValue === "") {
          setIsEmailPhoneVal(true);
          setLoginErrorMsg(errEmptyEmailOrPhone);
        } else if (!phoneValidation(emailPhoneValue)) {
          setIsEmailPhoneVal(true);
          setLoginErrorMsg(validEmail_OR_MobileNumberText);
        }
      }
    } else {
      if (!phoneValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
        if (emailPhoneValue === "") {
          setIsEmailPhoneVal(true);
          setLoginErrorMsg(errEmptyEmailOrPhone);
        } else if (!emailValidation(emailPhoneValue)) {
          setIsEmailPhoneVal(true);
          setLoginErrorMsg(validEmail_OR_MobileNumberText);
        }
      }
    }

    if (firstNameValidation(firstName) && (!isPhone ? emailValidation(emailPhoneValue) : phoneValidation(emailPhoneValue))) {
      if (isPhone) {
        let formData = new FormData();

        formData.append("first_name", firstName);
        formData.append("email_chr", '');
        formData.append("phone_code_id_int", parseInt(codeValue) || 1);
        formData.append("phone_number_int", parseInt(emailPhoneValue) || 0);
        formData.append("remark_message", messageText);

        setSubmitting(true);


        dispatch(guestHomeownerForumApi(formData, (res) => {
          setToasterType("success")
          setResponceMsg(res.data.message);
          setHandleToaster(true);

          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);

          setSubmitted(true);
          setSubmitting(false);
          

          // navigate("/activateUsers");

          // setTimeout(() => {
          //   setLoaderActive(false);
          //   navigate("/activateUsers");
          // }, 2000);

        }, (res) => {
          setToasterType("error")
          setResponceMsg(res.data.message);
          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
          setSubmitting(false)
        }))

      } else {
        let formData = new FormData();

        formData.append("first_name", firstName);
        formData.append("email_chr", emailPhoneValue);
        // formData.append("phone_code_id_int", parseInt(codeValue) || 1);
        // formData.append("phone_number_int", parseInt(emailPhoneValue) || 0);
        formData.append("remark_message", messageText);

        setSubmitting(true);


        dispatch(guestHomeownerForumApi(formData, (res) => {
          setToasterType("success")
          setResponceMsg(res.data.message);
          setHandleToaster(true);

          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);

          setSubmitted(true);
          setSubmitting(false);
          

          // navigate("/activateUsers");

          // setTimeout(() => {
          //   setLoaderActive(false);
          //   navigate("/activateUsers");
          // }, 2000);

        }, (res) => {
          setToasterType("error")
          setResponceMsg(res.data.message);
          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
          setSubmitting(false)
        }))

      }
    }

  };

  const handleDone = () => {
    onDone?.();
    onClose?.();
  };

  const handleFirstName = (e) => {
    setIsFirstNameError(false);
    setFirstName(e.target.value);
  };

  const handleEmailPhone = (e) => {
    // console.log(e.target.value);
    setIsEmailPhoneVal(false);
    noSpaceOnChange(e.target.value) && setEmailPhoneValue(e.target.value);

  };

  const handleDropdownValue = (e) => {
    // setCodeValue(e.target.value);
    setCodeValue(e);

  };

  function handleBlur() {
    if (isPhone) {
      if (emailPhoneValue === "") {
        setIsEmailPhoneVal(true);
        setLoginErrorMsg(errEmptyEmailOrPhone);
      } else if (!phoneValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
        setLoginErrorMsg(validEmail_OR_MobileNumberText);
      }
    } else {
      if (emailPhoneValue === "") {
        setIsEmailPhoneVal(true);
        setLoginErrorMsg(errEmptyEmailOrPhone);
      } else if (!emailValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
        setLoginErrorMsg(validEmail_OR_MobileNumberText);
      }
    }
  }

  useEffect(() => {
    const dot = ".";
    const leng = emailPhoneValue.length - 1;
    if (!isNaN(emailPhoneValue) && emailPhoneValue.charAt(leng) !== dot) {
      if (emailPhoneValue.length < 11) {
        setIsPhone(true);
      } else {
        setIsPhone(false);
      }
    } else {
      setIsPhone(false);
    }
    if (emailPhoneValue === "") {
      setIsPhone(false);
    }
  }, [emailPhoneValue]);

  const handleMessageText = (e) => {
    setMessageText(e.target.value);
  }


  if (submitted) {
    return (
      <div className="add-link-lead-form">
        <div className="add-link-lead-form__card">
          <div className="add-link-lead-form__success">
            <span className="add-link-lead-form__success-icon">✓</span>
            <h2 className="add-link-lead-form__title">Thanks!</h2>
            <p className="add-link-lead-form__sub">
              Your info was submitted. We&apos;ll reach out when you&apos;re ready.
            </p>
            <button
              type="button"
              className="add-link-pill-btn"
              onClick={handleDone}
            >
              Done
            </button>
          </div>
        </div>
      </div>
    );
  }





  return (
    <div className="add-link-lead-form">
      <div
        className="add-link-lead-form__backdrop"
        onClick={onClose}
        aria-hidden
      />
      <div className="add-link-lead-form__card" role="dialog" aria-modal="true">
        <button
          type="button"
          className="add-link-lead-form__close"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <h2 className="add-link-lead-form__title">{title}</h2>
        <p className="add-link-lead-form__sub">{prompt}</p>
        <form className="add-link-lead-form__fields" onSubmit={handleSubmit} noValidate>

          <div className="row d-flex justify-content-between mt-2">
            <div className="col-12">
              <InputField
                labelName={lblFirstName}
                value={firstName}
                onChange={handleFirstName}
                errorOccured={isFirstNameError}
                errorMeesage={errorFirstNameMsg}
                onBlur={() => { }}
                isRequired={true}
                autoF={true}
              />
            </div>
          </div>

          <div className="row mb-2">
            <EmailPhoneCombine
              isEnteringNumber={isPhone}
              setIsEnteringNumber={setIsPhone}
              handleInputValue={handleEmailPhone}
              handleChangeCode={handleDropdownValue}
              errorOccured={isEmailPhoneVal}
              inputValue={emailPhoneValue}
              handleOnBlur={handleBlur}
              defaultCodeValue={codeValue}
              errorMessage={
                // validEmail_OR_MobileNumberText
                loginErrorMsg
              }
              isRequired={true}
            />
          </div>

          <div className='mb-2 mx-0 row'>
            <div className='col-12 px-0'>
              <TextArea
                labelName={`Message`}
                placeholder={`Message`}
                value={messageText}
                onChange={handleMessageText}
                rows='3'
                onBlur={() => { }}
              />
            </div>
          </div>


          {/* {errors.contact && (
            <p className="add-link-lead-form__error add-link-lead-form__error--contact">
              {errors.contact}
            </p>
          )}
          {submitError && (
            <p className="add-link-lead-form__error add-link-lead-form__error--contact">
              {submitError}
            </p>
          )}
          <label className="add-link-lead-form__label">
            Name
            <input
              type="text"
              className={`add-link-lead-form__input${errors.name ? " is-error" : ""}`}
              value={fields.name}
              onChange={setField("name")}
              placeholder="Your name"
              autoComplete="name"
            />
            {errors.name && (
              <span className="add-link-lead-form__error">{errors.name}</span>
            )}
          </label>
          <label className="add-link-lead-form__label">
            Email
            <input
              type="email"
              className={`add-link-lead-form__input${errors.email ? " is-error" : ""}`}
              value={fields.email}
              onChange={setField("email")}
              placeholder="you@email.com"
              autoComplete="email"
            />
            {errors.email && (
              <span className="add-link-lead-form__error">{errors.email}</span>
            )}
          </label>
          <label className="add-link-lead-form__label">
            Phone
            <input
              type="tel"
              className={`add-link-lead-form__input${errors.phone ? " is-error" : ""}`}
              value={fields.phone}
              onChange={setField("phone")}
              placeholder="(555) 123-4567"
              autoComplete="tel"
            />
            {errors.phone && (
              <span className="add-link-lead-form__error">{errors.phone}</span>
            )}
          </label> */}


          <button
            type="submit"
            className="add-link-pill-btn add-link-lead-form__submit"
            disabled={submitting}
          >
            {submitting ? "Submitting…" : submitLabel}
          </button>
          <button
            type="button"
            className="add-link-pill-btn add-link-pill-btn--secondary"
            onClick={onClose}
            disabled={submitting}
          >
            Cancel
          </button>
        </form>
      </div>

      {handleToaster && (
        <ResponceToaster toasterType={toasterType} message={responceMsg} />
      )}
    </div>
  );
};
